import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewRef,LOCALE_ID } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatDrawer, MatSnackBar } from '@angular/material'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ONE_MB_IN_BYTES } from '../../../../../constants/FileSize'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { DialogService, DocumentService, DossierService, DroitsService, StateService } from '../../../../../services'

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';

const KEY = 'load-dialog'

@Component({
	selector: 'load-dialog',
	templateUrl: './load.component.html',
	styleUrls: ['./load.component.scss'],
  	providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
    //{ provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    {
      provide: MAT_DATE_FORMATS, useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMM YYYY',
        },
      }
    },
  ],
})
@Stringable({
	path: 'views/partials/layout/dialogs/load-dialog',
	key: KEY,
})
export class LoadDialogComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY) strings: any
 
	src:string="";
	url:string="";
	
	isdirect:boolean=false;
	isdownload:boolean=true;
	
	constructor(
		public dialogRef: MatDialogRef<LoadDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public stateService: StateService,
		public droitsService: DroitsService,
		private snackbar: MatSnackBar,
		changeDetectorRef: ChangeDetectorRef,
		private documentService: DocumentService,
		private dossierService: DossierService,
		dialogService: DialogService
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
	   
		if (this.data.direct!=undefined)
			this.isdirect=this.data.direct;
		if (this.data.download!=undefined)
			this.isdownload=this.data.download;
				
		if (this.data.url!=undefined) {
			this.url=this.data.url;
			this.src=this.url;
			if (!this.isdirect)
				this.src +="?view=true";
			if (this.data.urlParameters) {
				for (const [key, value] of Object.entries(this.data.urlParameters)) {
					this.src += "&" + key + "=" + value;
				}
			}
		}
		console.log("LoadDialogComponent init",this.data,this.src)
	}

	ngOnDestroy() {
		
	}
	
	download() {
		window.open(this.url, ' _blank')
	}
	
}
